import React from "react";
import { useNavigate } from "react-router-dom";
import { chinaConfig } from "./countries/China/config";
import { indiaConfig } from "./countries/India/config";
import { indonesiaConfig } from "./countries/Indonesia/config";
import { philippinesConfig } from "./countries/Philippines/config";
import { uaeConfig } from "./countries/UAE/config";
import {
  Container,
  Title,
  Subtitle,
  CountryGrid,
  CountryCard,
  Flag,
  CountryInfo,
  CountryName,
} from "./styles";

const countries = [
  chinaConfig,
  indiaConfig,
  indonesiaConfig,
  philippinesConfig,
  uaeConfig,
];

const CountrySelect: React.FC = () => {
  const navigate = useNavigate();

  const handleSelectCountry = (code: string) => {
    navigate(`/wallets/asia/payout/${code.toLowerCase()}`);
  };

  return (
    <Container>
      <Title>Where are you sending to?</Title>
      <Subtitle>Select your destination country and make payment</Subtitle>
      <CountryGrid>
        {countries.map((country) => (
          <CountryCard
            key={country.code}
            onClick={() => handleSelectCountry(country.code)}
          >
            <Flag><country.flag /></Flag>
            <CountryInfo>
              <CountryName>{country.name}</CountryName>
            </CountryInfo>
          </CountryCard>
        ))}
      </CountryGrid>
    </Container>
  );
};

export default CountrySelect;
